import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AvatarEditor, PersonalForm, EmailChange } from "@/components/shop/ProfileParts";
import { AddressBook } from "@/components/shop/AddressBook";
import { ChangePassword } from "@/components/shop/ChangePassword";
import { Loader } from "@/components/shop/ProtectedRoute";

export const ProfileTab = () => {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const load = () => api.get("/profile").then((r) => setP(r.data));
  useEffect(() => { load(); }, []);
  if (!p) return <Loader />;
  return (
    <div className="grid gap-5 lg:grid-cols-2" data-testid="profile-tab">
      <div className="space-y-5">
        <AvatarEditor picture={p.picture} onChange={(picture) => setP({ ...p, picture })} />
        <PersonalForm p={p} />
        <EmailChange p={p} onChange={load} />
        {user.auth_provider === "email" && <ChangePassword />}
      </div>
      <AddressBook addresses={p.addresses} onChange={(addresses) => setP({ ...p, addresses })} />
    </div>
  );
};
